import { Injectable } from '@angular/core';
import {
  isBorrowerFacilityWorkspaceRoute,
  isBorrowerPackagesParentRoute,
  isProductSetupConfigureRoute,
  isProductSetupListRoute,
  isReviewApplicationsDetailRoute,
  isReviewApplicationsListRoute,
} from '../utils/sidebar-nav.util';

/**
 * Collapses the main nav when opening focused workspaces (borrower application review,
 * facility product configure template, borrower facility workspace / configure form), and restores the
 * list-page collapsed state when navigating back (e.g. breadcrumb).
 */
@Injectable({ providedIn: 'root' })
export class SidebarNavService {
  /** Sidebar collapsed state on the review-applications list before entering detail. */
  private reviewListCollapsedBeforeDetail = false;

  /** Sidebar collapsed state on the product-setup list before entering configure. */
  private productSetupListCollapsedBeforeConfigure = false;

  /** Sidebar collapsed state on borrower-packages before entering facility workspace. */
  private borrowerPackagesCollapsedBeforeFacility = false;

  /**
   * @returns Next sidebar collapsed state, or `undefined` when navigation should not change it.
   */
  resolveSidebarForNavigation(
    previousUrl: string,
    nextUrl: string,
    currentCollapsed: boolean
  ): boolean | undefined {
    if (isReviewApplicationsDetailRoute(nextUrl)) {
      if (isReviewApplicationsListRoute(previousUrl)) {
        this.reviewListCollapsedBeforeDetail = currentCollapsed;
      }
      return true;
    }

    if (
      isReviewApplicationsDetailRoute(previousUrl) &&
      isReviewApplicationsListRoute(nextUrl)
    ) {
      return this.reviewListCollapsedBeforeDetail;
    }

    if (isProductSetupConfigureRoute(nextUrl)) {
      if (isProductSetupListRoute(previousUrl)) {
        this.productSetupListCollapsedBeforeConfigure = currentCollapsed;
      }
      return true;
    }

    if (isProductSetupConfigureRoute(previousUrl) && isProductSetupListRoute(nextUrl)) {
      return this.productSetupListCollapsedBeforeConfigure;
    }

    if (isBorrowerFacilityWorkspaceRoute(nextUrl)) {
      if (isBorrowerPackagesParentRoute(previousUrl)) {
        this.borrowerPackagesCollapsedBeforeFacility = currentCollapsed;
      }
      return true;
    }

    if (
      isBorrowerFacilityWorkspaceRoute(previousUrl) &&
      isBorrowerPackagesParentRoute(nextUrl)
    ) {
      return this.borrowerPackagesCollapsedBeforeFacility;
    }

    return undefined;
  }
}
